import { Component } from '@angular/core';

@Component({
  selector: 'tun-factory-settings-icon',
  templateUrl: './factory-settings-icon.component.html',
  styleUrls: ['./factory-settings-icon.component.scss'],
})
export class FactorySettingsIconComponent {}
